// FeedbackThumbs.tsx
import Box from "@mui/material/Box";
import { FeedbackType } from "../../../../API";
import { useHasRoleAccess } from "../../../../common/hooks/useCheckRoleAccess";
import FeedbackButton from "../../../../common/components/item/FeedbackButton";

interface FeedbackThumbsProps {
  timestamp: string;
  feedback?: FeedbackType;
  mitigatedRisk?: string[] | null;
  onThumbUpClick: () => Promise<void>;
  onThumbsDownClick: () => Promise<void>;
}

const FeedbackThumbs = ({
  feedback,
  onThumbUpClick,
  onThumbsDownClick,
}: FeedbackThumbsProps) => {
  const isDeniedAccess = useHasRoleAccess("readonly");

  const confirmNegativeFeedback = async () => {
    if (feedback === FeedbackType.NEGATIVE) return;

    await onThumbsDownClick();
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: "0.5em",
        cursor: isDeniedAccess ? "default" : "pointer",
      }}
    >
      <FeedbackButton
        type="up"
        feedback={feedback}
        isDisabled={isDeniedAccess}
        onClick={onThumbUpClick}
        className="thumb-up"
        ariaLabel="thumb-up"
      />

      <FeedbackButton
        type="down"
        feedback={feedback}
        isDisabled={isDeniedAccess}
        onClick={confirmNegativeFeedback}
        className="thumb-down"
        ariaLabel="thumb-down"
      />
    </Box>
  );
};

export default FeedbackThumbs;
